export default "__VITE_ASSET__i$kw$3cb__"